import { FC } from "react";
// 组件
import { PlusOutlined } from "@ant-design/icons";
// 常量
import { AddCardItemProps } from "./interface";

/** 新增卡片 */
const AddCardItem: FC<AddCardItemProps> = props => {
  const { style, addIcon, addText, onAdd, } = props;
  return (
    <div className="yb-card-item-wrapper" style={style}>
      <div className="yb-card-add">
        <div className="yb-card-add-btn" onClick={onAdd}>
          <span className="yb-card-add-icon">
            {addIcon}
          </span>
        </div>
        <div className="yb-card-add-text">{addText}</div>
      </div>
    </div>
  );
};

AddCardItem.defaultProps = {
  addIcon: <PlusOutlined />,
  addText: '新增',
};

export default AddCardItem;
